/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import idIcon from "../../assets/icons/progress/icon_progressbar_personal_data.svg";
import divorceIcon from "../../assets/icons/progress/icon_progressbar_divorce.svg";
import financeIcon from "../../assets/icons/progress/icon_progressbar_finance.svg";
import insuranceIcon from "../../assets/icons/progress/icon_progressbar_versicherung.svg";

const getProgressBarSteps = (withInsurance: boolean) => [
  {
    key: "divorce",
    name: "Ehe und Scheidung",
    icon: divorceIcon,
  },
  {
    key: "finance",
    name: "Finanzen",
    icon: financeIcon,
  },
  {
    key: "personal",
    name: "Persönliche Angaben",
    icon: idIcon,
  },
  ...(withInsurance
    ? [
        {
          key: "insurance",
          name: "Versicherung",
          icon: insuranceIcon,
        },
      ]
    : []),
];

export default getProgressBarSteps;
